module.exports = __webpack_public_path__ + "static/media/bg5.44bcb7f1.jpg";